<mat-card class="validate-card">
    <mat-card-header>
        <mat-card-title><fa-icon [icon]="['fas','user-md']"></fa-icon>&nbsp;&nbsp;Médicale</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="flex-container" fxLayout="row" fxLayoutGap="5px">
            <app-doctor-selection class="field-full-width" [doctor]="patient.doctor" (selected)="doctorSelected($event)"></app-doctor-selection>
        </div>
    </mat-card-content>
</mat-card>